import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-new-payments',
  templateUrl: './usr-new-payments.component.html',
  styleUrls: ['./usr-new-payments.component.css']
})
export class UsrNewPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
